import * as React from "react";
import Button from "../../../components/Button";

interface ICategorySortButtonHeaderProps {
    editMode: boolean;
    canEdit: boolean;
    disabled: boolean;

    onEditClick: () => void;
    onReload: () => void;

    t: reactI18Next.TranslationFunction;
}

export const CategorySortButtonHeader: React.SFC<ICategorySortButtonHeaderProps> = (props: ICategorySortButtonHeaderProps) => {

    return (
        <>
            {props.canEdit &&
                <Button
                    disabled={props.disabled}
                    icon={props.editMode ? "close" : "pencil"}
                    label={props.t(props.editMode ? "GLOBAL:STOP_EDITING" : "GLOBAL:START_EDITING")}
                    labelPosition={"after"}
                    onClick={props.onEditClick}
                />
            }
            <Button
                disabled={props.disabled}
                icon={"refresh"}
                label={props.t("GLOBAL:RELOAD")}
                labelPosition={"after"}
                onClick={props.onReload}
            />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/views/AdminView/CategorySortTab/CategorySortButtonHeader.tsx